// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__1yLjj","checkmark":"checkbox_checkmark__2Rvo_"};